<template>
  <div class="col-xl-3 col-lg-4">

    <!-- sidebar-category start -->
    <shop-sidebar-web-category></shop-sidebar-web-category>
    <!-- sidebar-category end -->

    <!-- sidebar-category start -->
    <shop-sidebar-category v-if="$route.query.web_category"></shop-sidebar-category>
    <!-- sidebar-category end -->

    <!-- sidebar-price start -->
    <shop-sidebar-price></shop-sidebar-price>
    <!-- sidebar-price end -->

    <!-- sidebar-color start -->
    <shop-sidebar-color></shop-sidebar-color>
    <!-- sidebar-color end -->

    <!-- sidebar-rating start -->
    <shop-sidebar-rating></shop-sidebar-rating>
    <!-- sidebar-rating end -->

    <!-- sidebar-brands start -->
    <shop-sidebar-brands v-if="$route.query.web_category" />
    <!-- sidebar-brands end -->

    <!-- sidebar-sizes start -->
    <!-- <shop-sidebar-sizes></shop-sidebar-sizes> -->
    <!-- sidebar-sizes end -->

    <!-- sidebar-offers start -->
    <!-- <div class="product-widget mb-30">
      <h5 class="pt-title">Special Offers</h5>
      <div class="product__sm mt-20">
        <ul>
          <li v-for="p in offer_products" :key="p.id" class="product__sm-item d-flex align-items-center">
            <div class="product__sm-thumb mr-20">
              <nuxt-link :to="`/shop-details/${p.id}`">
                <img :src="p.image" alt="">
              </nuxt-link>
            </div>
            <div class="product__sm-content">
              <h5 class="product__sm-title">
                <nuxt-link :to="`/shop-details/${p.id}`">{{ p.title }}</nuxt-link>
              </h5>
              <div class="product__sm-price">
                <span class="price">${{ p.price.toFixed(2) }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <!-- sidebar-offers end -->

    <!-- reset filter start -->
    <div class="product-widget mb-30">
      <h5 class="pt-title">Reset Filter</h5>
      <div class="price__slider mt-30">
        <div>
          <div class="s-form mt-20 d-flex justify-content-between">
            <button @click="resetFilter" class="cart-btn reset-filter-btn">Reset Filter</button>
          </div>
        </div>
      </div>
    </div>
    <!-- reset filter end -->

  </div>
</template>

<script>
import product_data from "@/data/product-data";
import ShopSidebarWebCategory from '@/components/shop/sidebar/shop-sidebar-web-category.vue';
import ShopSidebarCategory from '@/components/shop/sidebar/shop-sidebar-category.vue';
import ShopSidebarBrands from '@/components/shop/sidebar/shop-sidebar-brands.vue';
// import ShopSidebarSizes from '@/components/shop/sidebar/shop-sidebar-sizes.vue';


export default {
  name: "ShopSidebar",
  components: {
    ShopSidebarWebCategory,
    ShopSidebarCategory,
    ShopSidebarBrands,
    // ShopSidebarSizes
    },
  data() {
    return {
      offer_products: [...product_data].filter(p => p.discount_percentage !== 0).slice(0, 3)
    };
  },

  methods: {
    resetFilter() {
      this.$router.push("/shop");
    }
  }
};
</script>

<style scoped>
.reset-filter-btn {
  border-radius: 999px;
  padding-left: 24px;
  padding-right: 24px;
}
</style>